<button
  (click)="clickSearch()"
  type="button"
  mat-icon-button>
  <mat-icon> search</mat-icon>
</button>
